import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
// import posthog from "posthog-js";
import App from "./App";
import AppLoader from "./components/loader";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/configureStore";
import common_en from "./translations/en/index.json";
import common_fr from "./translations/fr/index.json";
import common_ge from "./translations/ge/index.json";
import "./index.css";

// Make sure HyperDX is initialized.
// This is typically done once, early in your application setup.
// For example:
// import { HyperDX } from '@hyperdx/browser';
// HyperDX.init({
//   apiKey: 'YOUR_HYPERDX_API_KEY',
//   service: 'your-app-name',
//   tracePropagationTargets: [/localhost/, /your-backend-domain/],
// });

// const api_Key = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;

// posthog.init(api_Key, {
//   api_host: "https://us.i.posthog.com",
//   person_profiles: "identified_only",
// });

const root = ReactDOM.createRoot(document.getElementById("root"));

i18next.init({
  lng: "en",
  debug: false,
  resources: {
    en: {
      common: common_en,
    },
    fr: {
      common: common_fr,
    },
    ge: {
      common: common_ge,
    },
  },
});

root.render(
  <I18nextProvider i18n={i18next}>
    <Provider store={store}>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="w-screen h-screen center">
              <AppLoader />
            </div>
          }
        >
          <App />
        </Suspense>
      </BrowserRouter>
    </Provider>
  </I18nextProvider>
);

// Function to send web vitals to analytics services
const sendVitalsToAnalytics = (metric) => {
  // Send to HyperDX
  // if (typeof HyperDX !== 'undefined' && HyperDX.captureEvent) {
  //   HyperDX.captureEvent(`web_vital_${metric.name.toLowerCase()}`, {
  //     value: metric.value,
  //     delta: metric.delta,
  //     id: metric.id,
  //     navigationType: metric.navigationType,
  //   });
  //   // console.log(`Web Vital ${metric.name} sent to HyperDX:`, metric.value);
  // } else {
  //   console.warn('HyperDX SDK not found. Web Vital not sent to HyperDX:', metric);
  // }

  // Send to Plausible.io
  if (window.plausible) {
    window.plausible("Web Vitals", {
      props: {
        metricName: metric.name,
        value: metric.value,
        delta: metric.delta,
        id: metric.id,
        navigationType: metric.navigationType,
      },
    });
    // console.log(`Web Vital ${metric.name} sent to Plausible:`, metric.value);
  } else {
    console.warn(
      "Plausible not found. Web Vital not sent to Plausible:",
      metric
    );
  }

  // Fallback or log if neither SDK is available (optional)
  // if ((typeof HyperDX === 'undefined' || !HyperDX.captureEvent) && !window.plausible) {
  // console.log('Web Vital (no analytics configured):', metric);
  // }
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendVitalsToAnalytics);
